var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[_c('GlobalHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"container m-auto my-3"},[_c('Form')],1),_c('Sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }